import React from 'react'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import CajasAbiertas from '../../Components/Admin/CajasAbiertas/CajasAbiertas'
import ReporteCajas from '../../Components/Admin/ReporteCajas/ReporteCajas'
import MetodosTransferencia from '../../Components/Admin/MetodosTransferencia/MetodosTransferencia'

export default function Cajas() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <MetodosTransferencia />
                    <CajasAbiertas />
                    <ReporteCajas />
                </div>
            </section>
        </div>
    )
}
